import { useSetAtom } from 'jotai'
import { ReactNode, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { parseLocale, setDocumentLang } from './locale-utils'
import { localeState } from './store'

export default function I18nProvider({ children }: { children: ReactNode }) {
  const [searchParams] = useSearchParams()
  const setLocale = useSetAtom(localeState)

  useEffect(() => {
    const locale = parseLocale(searchParams.get('language'))
    setLocale(locale)
    setDocumentLang(locale)
  }, [searchParams, setLocale])

  return <>{children}</>
}
